import dayjs from "dayjs";

import { priceToString } from "../../shared/utils/format-money";
import { OrderHistoryEvent, OrderRow, paymentLabel } from "./Orders/orderTypes";

type BaseOrder = Omit<OrderRow, "history">;

const baseOrders: BaseOrder[] = [
	{
		id: "1",
		orderNumber: "#100234",
		date: "2026-09-18T09:12:32",
		client: "Ana Souza",
		email: "ana.souza@gmail.com",
		document: "01677790820",
		clientPhone: "(11) 90000-137",
		clientAddress:
			"Rua das Palmeiras, 137 - Centro, São Paulo - SP, CEP 10002-221",
		clientSince: "2024-06-02",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "ABC1D23",
		queryCode: "CS-100234",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Ana Souza",
			maskedNumber: "544915******0137",
			expiration: "02/2029",
		},
	},
	{
		id: "2",
		orderNumber: "#100233",
		date: "2026-09-18T08:51:27",
		client: "Bruno Lima",
		email: "bruno.lima@hotmail.com",
		document: "45123678000199",
		clientPhone: "(21) 90000-274",
		clientAddress:
			"Av. Brasil, 174 - Jardim Europa, Rio de Janeiro - RJ, CEP 10004-442",
		clientSince: "2023-03-03",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "XYZ4E56",
		queryCode: "CS-100233",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "7f3c02a1-9b2e-4d5f-8a6c-0002e1b2c3d4",
	},
	{
		id: "3",
		orderNumber: "#100232",
		date: "2026-09-17T21:54:30",
		client: "Carla Dias",
		email: "carla.dias@outlook.com",
		document: "98765432100",
		clientPhone: "(31) 90000-411",
		clientAddress:
			"Rua Sete de Setembro, 211 - Vila Mariana, Belo Horizonte - MG, CEP 10006-663",
		clientSince: "2021-12-04",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "JKL7F89",
		queryCode: "CS-100232",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Carla Dias",
			maskedNumber: "544915******0411",
			expiration: "04/2031",
		},
	},
	{
		id: "4",
		orderNumber: "#100231",
		date: "2026-09-15T14:02:10",
		client: "Daniel Alves",
		email: "daniel.alves@yahoo.com",
		document: "32165498700",
		clientPhone: "(41) 90000-548",
		clientAddress:
			"Av. Paulista, 248 - Boa Vista, Porto Alegre - RS, CEP 10008-884",
		clientSince: "2025-09-05",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "MNO4P56",
		queryCode: "CS-100231",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "32165498700",
	},
	{
		id: "5",
		orderNumber: "#100230",
		date: "2026-09-14T11:37:45",
		client: "Eduarda Ramos",
		email: "eduarda.ramos@gmail.com",
		document: "12345678000155",
		clientPhone: "(51) 90000-685",
		clientAddress:
			"Rua das Flores, 285 - Petrópolis, Curitiba - PR, CEP 10011-105",
		clientSince: "2024-06-06",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "QRS7T89",
		queryCode: "CS-100230",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Eduarda Ramos",
			maskedNumber: "544915******0685",
			expiration: "06/2028",
		},
	},
	{
		id: "6",
		orderNumber: "#100229",
		date: "2026-09-14T09:20:00",
		client: "Felipe Santos",
		email: "felipe.santos@hotmail.com",
		document: "78912345600",
		clientPhone: "(61) 90000-822",
		clientAddress:
			"Av. Getúlio Vargas, 322 - Copacabana, Salvador - BA, CEP 10013-326",
		clientSince: "2023-03-07",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "UVW1X23",
		queryCode: "CS-100229",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 3,
		pixKey: "felipe.santos@hotmail.com",
	},
	{
		id: "7",
		orderNumber: "#100228",
		date: "2026-09-13T18:45:53",
		client: "Gabriela Nunes",
		email: "gabriela.nunes@outlook.com",
		document: "65498732000110",
		clientPhone: "(71) 90000-959",
		clientAddress:
			"Rua XV de Novembro, 359 - Savassi, Fortaleza - CE, CEP 10015-547",
		clientSince: "2021-12-08",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "YZA4B56",
		queryCode: "CS-100228",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Gabriela Nunes",
			maskedNumber: "544915******0959",
			expiration: "08/2030",
		},
	},
	{
		id: "8",
		orderNumber: "#100227",
		date: "2026-09-12T08:15:22",
		client: "Henrique Melo",
		email: "henrique.melo@gmail.com",
		document: "15975346800",
		clientPhone: "(81) 90001-096",
		clientAddress: "Av. Rio Branco, 396 - Batel, Recife - PE, CEP 10017-768",
		clientSince: "2025-09-09",
		status: "Enviado",
		queryType: "Checkauto Standard",
		plate: "CDE7F89",
		queryCode: "CS-100227",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "7f3c08a1-9b2e-4d5f-8a6c-0008e1b2c3d4",
	},
	{
		id: "9",
		orderNumber: "#100226",
		date: "2026-09-10T16:30:07",
		client: "Isabela Costa",
		email: "isabela.costa@yahoo.com",
		document: "78945612000133",
		clientPhone: "(85) 90001-233",
		clientAddress:
			"Rua São João, 433 - Moinhos de Vento, Florianópolis - SC, CEP 10019-989",
		clientSince: "2024-06-10",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "GHI1J23",
		queryCode: "CS-100226",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Isabela Costa",
			maskedNumber: "544915******1233",
			expiration: "10/2032",
		},
	},
	{
		id: "10",
		orderNumber: "#100225",
		date: "2026-09-08T10:05:41",
		client: "João Pedro",
		email: "joao.pedro@hotmail.com",
		document: "25836914700",
		clientPhone: "(47) 90001-370",
		clientAddress:
			"Rua das Acácias, 470 - Higienópolis, Brasília - DF, CEP 10022-210",
		clientSince: "2023-03-11",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "KLM4N56",
		queryCode: "CS-100225",
		queryResultStatus: "success",
		value: 69.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "25836914700",
	},
	{
		id: "11",
		orderNumber: "#100213",
		date: "2026-08-24T09:17:00",
		client: "Lucas Barros",
		email: "lucas.barros@hotmail.com",
		document: "10000001067",
		clientPhone: "(11) 90001-507",
		clientAddress:
			"Rua das Palmeiras, 507 - Centro, São Paulo - SP, CEP 10024-431",
		clientSince: "2021-11-12",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "LMN1033",
		queryCode: "CS-100213",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Lucas Barros",
			maskedNumber: "544915******1507",
			expiration: "12/2029",
		},
	},
	{
		id: "12",
		orderNumber: "#100212",
		date: "2026-08-25T10:24:00",
		client: "Mariana Pires",
		email: "mariana.pires@gmail.com",
		document: "10000000001644",
		clientPhone: "(21) 90001-644",
		clientAddress:
			"Av. Brasil, 544 - Jardim Europa, Rio de Janeiro - RJ, CEP 10026-652",
		clientSince: "2025-08-13",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "MNO1036",
		queryCode: "CS-100212",
		queryResultStatus: "unavailable",
		value: 69.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "mariana.pires@gmail.com",
	},
	{
		id: "13",
		orderNumber: "#100211",
		date: "2026-08-26T11:31:00",
		client: "Nicolas Teixeira",
		email: "nicolas.teixeira@hotmail.com",
		document: "10000001261",
		clientPhone: "(31) 90001-781",
		clientAddress:
			"Rua Sete de Setembro, 581 - Vila Mariana, Belo Horizonte - MG, CEP 10028-873",
		clientSince: "2024-05-14",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "NOP1039",
		queryCode: "CS-100211",
		queryResultStatus: "success",
		value: 54.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Nicolas Teixeira",
			maskedNumber: "544915******1781",
			expiration: "02/2031",
		},
	},
	{
		id: "14",
		orderNumber: "#100210",
		date: "2026-08-27T12:38:00",
		client: "Olivia Rocha",
		email: "olivia.rocha@gmail.com",
		document: "10000001358",
		clientPhone: "(41) 90001-918",
		clientAddress:
			"Av. Paulista, 618 - Boa Vista, Porto Alegre - RS, CEP 10031-094",
		clientSince: "2023-02-15",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "OPQ1042",
		queryCode: "CS-100210",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "7f3c14a1-9b2e-4d5f-8a6c-0014e1b2c3d4",
	},
	{
		id: "15",
		orderNumber: "#100209",
		date: "2026-08-28T13:45:00",
		client: "Pedro Cardoso",
		email: "pedro.cardoso@hotmail.com",
		document: "10000000002055",
		clientPhone: "(51) 90002-055",
		clientAddress:
			"Rua das Flores, 655 - Petrópolis, Curitiba - PR, CEP 10033-315",
		clientSince: "2021-11-16",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "PQR1045",
		queryCode: "CS-100209",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Pedro Cardoso",
			maskedNumber: "544915******2055",
			expiration: "04/2028",
		},
	},
	{
		id: "16",
		orderNumber: "#100208",
		date: "2026-08-29T14:52:00",
		client: "Queila Martins",
		email: "queila.martins@gmail.com",
		document: "10000001552",
		clientPhone: "(61) 90002-192",
		clientAddress:
			"Av. Getúlio Vargas, 692 - Copacabana, Salvador - BA, CEP 10035-536",
		clientSince: "2025-08-17",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "QRS1048",
		queryCode: "CS-100208",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "10000001552",
	},
	{
		id: "17",
		orderNumber: "#100207",
		date: "2026-08-30T15:59:00",
		client: "Rafael Gomes",
		email: "rafael.gomes@hotmail.com",
		document: "10000001649",
		clientPhone: "(71) 90002-329",
		clientAddress:
			"Rua XV de Novembro, 729 - Savassi, Fortaleza - CE, CEP 10037-757",
		clientSince: "2024-05-18",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "RST1051",
		queryCode: "CS-100207",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Rafael Gomes",
			maskedNumber: "544915******2329",
			expiration: "06/2030",
		},
	},
	{
		id: "18",
		orderNumber: "#100206",
		date: "2026-08-31T16:06:00",
		client: "Sabrina Vieira",
		email: "sabrina.vieira@gmail.com",
		document: "10000000002466",
		clientPhone: "(81) 90002-466",
		clientAddress: "Av. Rio Branco, 766 - Batel, Recife - PE, CEP 10039-978",
		clientSince: "2023-02-19",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "STU1054",
		queryCode: "CS-100206",
		queryResultStatus: "unavailable",
		value: 69.9,
		payment: "pix",
		queryQuantity: 3,
		pixKey: "sabrina.vieira@gmail.com",
	},
	{
		id: "19",
		orderNumber: "#100205",
		date: "2026-09-01T17:13:00",
		client: "Thiago Farias",
		email: "thiago.farias@hotmail.com",
		document: "10000001843",
		clientPhone: "(85) 90002-603",
		clientAddress:
			"Rua São João, 803 - Moinhos de Vento, Florianópolis - SC, CEP 10042-199",
		clientSince: "2021-12-20",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "TUV1057",
		queryCode: "CS-100205",
		queryResultStatus: "success",
		value: 54.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Thiago Farias",
			maskedNumber: "544915******2603",
			expiration: "08/2032",
		},
	},
	{
		id: "20",
		orderNumber: "#100204",
		date: "2026-09-02T08:20:00",
		client: "Ana Souza",
		email: "ana.souza@gmail.com",
		document: "10000001940",
		clientPhone: "(47) 90002-740",
		clientAddress:
			"Rua das Acácias, 840 - Higienópolis, Brasília - DF, CEP 10044-420",
		clientSince: "2025-09-21",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "UVW1060",
		queryCode: "CS-100204",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "7f3c20a1-9b2e-4d5f-8a6c-0020e1b2c3d4",
	},
	{
		id: "21",
		orderNumber: "#100203",
		date: "2026-09-03T09:27:00",
		client: "Bruno Lima",
		email: "bruno.lima@hotmail.com",
		document: "10000000002877",
		clientPhone: "(11) 90002-877",
		clientAddress:
			"Rua das Palmeiras, 877 - Centro, São Paulo - SP, CEP 10046-641",
		clientSince: "2024-06-22",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "VWX1063",
		queryCode: "CS-100203",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Bruno Lima",
			maskedNumber: "544915******2877",
			expiration: "10/2029",
		},
	},
	{
		id: "22",
		orderNumber: "#100202",
		date: "2026-09-04T10:34:00",
		client: "Carla Dias",
		email: "carla.dias@gmail.com",
		document: "10000002134",
		clientPhone: "(21) 90003-014",
		clientAddress:
			"Av. Brasil, 914 - Jardim Europa, Rio de Janeiro - RJ, CEP 10048-862",
		clientSince: "2023-03-23",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "WXY1066",
		queryCode: "CS-100202",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "10000002134",
	},
	{
		id: "23",
		orderNumber: "#100201",
		date: "2026-09-05T11:41:00",
		client: "Daniel Alves",
		email: "daniel.alves@hotmail.com",
		document: "10000002231",
		clientPhone: "(31) 90003-151",
		clientAddress:
			"Rua Sete de Setembro, 951 - Vila Mariana, Belo Horizonte - MG, CEP 10051-083",
		clientSince: "2021-12-24",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "XYZ1069",
		queryCode: "CS-100201",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Daniel Alves",
			maskedNumber: "544915******3151",
			expiration: "12/2031",
		},
	},
	{
		id: "24",
		orderNumber: "#100200",
		date: "2026-09-06T12:48:00",
		client: "Eduarda Ramos",
		email: "eduarda.ramos@gmail.com",
		document: "10000000003288",
		clientPhone: "(41) 90003-288",
		clientAddress:
			"Av. Paulista, 988 - Boa Vista, Porto Alegre - RS, CEP 10053-304",
		clientSince: "2025-09-25",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "YZC1072",
		queryCode: "CS-100200",
		queryResultStatus: "unavailable",
		value: 69.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "eduarda.ramos@gmail.com",
	},
	{
		id: "25",
		orderNumber: "#100199",
		date: "2026-09-07T13:55:00",
		client: "Felipe Santos",
		email: "felipe.santos@hotmail.com",
		document: "10000002425",
		clientPhone: "(51) 90003-425",
		clientAddress:
			"Rua das Flores, 125 - Petrópolis, Curitiba - PR, CEP 10055-525",
		clientSince: "2024-06-26",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "ZBD1075",
		queryCode: "CS-100199",
		queryResultStatus: "success",
		value: 54.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Felipe Santos",
			maskedNumber: "544915******3425",
			expiration: "02/2028",
		},
	},
	{
		id: "26",
		orderNumber: "#100198",
		date: "2026-08-24T14:02:00",
		client: "Gabriela Nunes",
		email: "gabriela.nunes@gmail.com",
		document: "10000002522",
		clientPhone: "(61) 90003-562",
		clientAddress:
			"Av. Getúlio Vargas, 162 - Copacabana, Salvador - BA, CEP 10057-746",
		clientSince: "2023-02-27",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "ACE1078",
		queryCode: "CS-100198",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "7f3c26a1-9b2e-4d5f-8a6c-0026e1b2c3d4",
	},
	{
		id: "27",
		orderNumber: "#100197",
		date: "2026-08-25T15:09:00",
		client: "Henrique Melo",
		email: "henrique.melo@hotmail.com",
		document: "10000000003699",
		clientPhone: "(71) 90003-699",
		clientAddress:
			"Rua XV de Novembro, 199 - Savassi, Fortaleza - CE, CEP 10059-967",
		clientSince: "2021-11-01",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "BDF1081",
		queryCode: "CS-100197",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Henrique Melo",
			maskedNumber: "544915******3699",
			expiration: "04/2030",
		},
	},
	{
		id: "28",
		orderNumber: "#100196",
		date: "2026-08-26T16:16:00",
		client: "Isabela Costa",
		email: "isabela.costa@gmail.com",
		document: "10000002716",
		clientPhone: "(81) 90003-836",
		clientAddress: "Av. Rio Branco, 236 - Batel, Recife - PE, CEP 10062-188",
		clientSince: "2025-08-02",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "CEG1084",
		queryCode: "CS-100196",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "10000002716",
	},
	{
		id: "29",
		orderNumber: "#100195",
		date: "2026-08-27T17:23:00",
		client: "João Pedro",
		email: "joao.pedro@hotmail.com",
		document: "10000002813",
		clientPhone: "(85) 90003-973",
		clientAddress:
			"Rua São João, 273 - Moinhos de Vento, Florianópolis - SC, CEP 10064-409",
		clientSince: "2024-05-03",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "DFH1087",
		queryCode: "CS-100195",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "João Pedro",
			maskedNumber: "544915******3973",
			expiration: "06/2032",
		},
	},
	{
		id: "30",
		orderNumber: "#100194",
		date: "2026-08-28T08:30:00",
		client: "Karina Freitas",
		email: "karina.freitas@gmail.com",
		document: "10000000004110",
		clientPhone: "(47) 90004-110",
		clientAddress:
			"Rua das Acácias, 310 - Higienópolis, Brasília - DF, CEP 10066-630",
		clientSince: "2023-02-04",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "EGI1090",
		queryCode: "CS-100194",
		queryResultStatus: "unavailable",
		value: 69.9,
		payment: "pix",
		queryQuantity: 3,
		pixKey: "karina.freitas@gmail.com",
	},
	{
		id: "31",
		orderNumber: "#100193",
		date: "2026-08-29T09:37:00",
		client: "Lucas Barros",
		email: "lucas.barros@hotmail.com",
		document: "10000003007",
		clientPhone: "(11) 90004-247",
		clientAddress:
			"Rua das Palmeiras, 347 - Centro, São Paulo - SP, CEP 10068-851",
		clientSince: "2021-11-05",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "FHJ1093",
		queryCode: "CS-100193",
		queryResultStatus: "success",
		value: 54.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Lucas Barros",
			maskedNumber: "544915******4247",
			expiration: "08/2029",
		},
	},
	{
		id: "32",
		orderNumber: "#100192",
		date: "2026-08-30T10:44:00",
		client: "Mariana Pires",
		email: "mariana.pires@gmail.com",
		document: "10000003104",
		clientPhone: "(21) 90004-384",
		clientAddress:
			"Av. Brasil, 384 - Jardim Europa, Rio de Janeiro - RJ, CEP 10071-072",
		clientSince: "2025-08-06",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "GIK1096",
		queryCode: "CS-100192",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "7f3c32a1-9b2e-4d5f-8a6c-0032e1b2c3d4",
	},
	{
		id: "33",
		orderNumber: "#100191",
		date: "2026-08-31T11:51:00",
		client: "Nicolas Teixeira",
		email: "nicolas.teixeira@hotmail.com",
		document: "10000000004521",
		clientPhone: "(31) 90004-521",
		clientAddress:
			"Rua Sete de Setembro, 421 - Vila Mariana, Belo Horizonte - MG, CEP 10073-293",
		clientSince: "2024-05-07",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "HJL1099",
		queryCode: "CS-100191",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Nicolas Teixeira",
			maskedNumber: "544915******4521",
			expiration: "10/2031",
		},
	},
	{
		id: "34",
		orderNumber: "#100190",
		date: "2026-09-01T12:58:00",
		client: "Olivia Rocha",
		email: "olivia.rocha@gmail.com",
		document: "10000003298",
		clientPhone: "(41) 90004-658",
		clientAddress:
			"Av. Paulista, 458 - Boa Vista, Porto Alegre - RS, CEP 10075-514",
		clientSince: "2023-03-08",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "IKM1102",
		queryCode: "CS-100190",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "10000003298",
	},
	{
		id: "35",
		orderNumber: "#100189",
		date: "2026-09-02T13:05:00",
		client: "Pedro Cardoso",
		email: "pedro.cardoso@hotmail.com",
		document: "10000003395",
		clientPhone: "(51) 90004-795",
		clientAddress:
			"Rua das Flores, 495 - Petrópolis, Curitiba - PR, CEP 10077-735",
		clientSince: "2021-12-09",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "JLN1105",
		queryCode: "CS-100189",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Pedro Cardoso",
			maskedNumber: "544915******4795",
			expiration: "12/2028",
		},
	},
	{
		id: "36",
		orderNumber: "#100188",
		date: "2026-09-03T14:12:00",
		client: "Queila Martins",
		email: "queila.martins@gmail.com",
		document: "10000000004932",
		clientPhone: "(61) 90004-932",
		clientAddress:
			"Av. Getúlio Vargas, 532 - Copacabana, Salvador - BA, CEP 10079-956",
		clientSince: "2025-09-10",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "KMO1108",
		queryCode: "CS-100188",
		queryResultStatus: "unavailable",
		value: 69.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "queila.martins@gmail.com",
	},
	{
		id: "37",
		orderNumber: "#100187",
		date: "2026-09-04T15:19:00",
		client: "Rafael Gomes",
		email: "rafael.gomes@hotmail.com",
		document: "10000003589",
		clientPhone: "(71) 90005-069",
		clientAddress:
			"Rua XV de Novembro, 569 - Savassi, Fortaleza - CE, CEP 10082-177",
		clientSince: "2024-06-11",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "LNP1111",
		queryCode: "CS-100187",
		queryResultStatus: "success",
		value: 54.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Rafael Gomes",
			maskedNumber: "544915******5069",
			expiration: "02/2030",
		},
	},
	{
		id: "38",
		orderNumber: "#100186",
		date: "2026-09-05T16:26:00",
		client: "Sabrina Vieira",
		email: "sabrina.vieira@gmail.com",
		document: "10000003686",
		clientPhone: "(81) 90005-206",
		clientAddress: "Av. Rio Branco, 606 - Batel, Recife - PE, CEP 10084-398",
		clientSince: "2023-03-12",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "MOQ1114",
		queryCode: "CS-100186",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 1,
		pixKey: "7f3c38a1-9b2e-4d5f-8a6c-0038e1b2c3d4",
	},
	{
		id: "39",
		orderNumber: "#100185",
		date: "2026-09-06T17:33:00",
		client: "Thiago Farias",
		email: "thiago.farias@hotmail.com",
		document: "10000000005343",
		clientPhone: "(85) 90005-343",
		clientAddress:
			"Rua São João, 643 - Moinhos de Vento, Florianópolis - SC, CEP 10086-619",
		clientSince: "2021-12-13",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "NPR1117",
		queryCode: "CS-100185",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Thiago Farias",
			maskedNumber: "544915******5343",
			expiration: "04/2032",
		},
	},
	{
		id: "40",
		orderNumber: "#100184",
		date: "2026-09-07T08:40:00",
		client: "Ana Souza",
		email: "ana.souza@gmail.com",
		document: "10000003880",
		clientPhone: "(47) 90005-480",
		clientAddress:
			"Rua das Acácias, 680 - Higienópolis, Brasília - DF, CEP 10088-840",
		clientSince: "2025-09-14",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "OQS1120",
		queryCode: "CS-100184",
		queryResultStatus: "success",
		value: 54.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "10000003880",
	},
	{
		id: "41",
		orderNumber: "#100183",
		date: "2026-08-24T09:47:00",
		client: "Bruno Lima",
		email: "bruno.lima@hotmail.com",
		document: "10000003977",
		clientPhone: "(11) 90005-617",
		clientAddress:
			"Rua das Palmeiras, 717 - Centro, São Paulo - SP, CEP 10091-061",
		clientSince: "2024-05-15",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "PRT1123",
		queryCode: "CS-100183",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Bruno Lima",
			maskedNumber: "544915******5617",
			expiration: "06/2029",
		},
	},
	{
		id: "42",
		orderNumber: "#100182",
		date: "2026-08-25T10:54:00",
		client: "Carla Dias",
		email: "carla.dias@gmail.com",
		document: "10000000005754",
		clientPhone: "(21) 90005-754",
		clientAddress:
			"Av. Brasil, 754 - Jardim Europa, Rio de Janeiro - RJ, CEP 10093-282",
		clientSince: "2023-02-16",
		status: "Concluído",
		queryType: "Checkauto Plus",
		plate: "QSU1126",
		queryCode: "CS-100182",
		queryResultStatus: "unavailable",
		value: 69.9,
		payment: "pix",
		queryQuantity: 3,
		pixKey: "carla.dias@gmail.com",
	},
	{
		id: "43",
		orderNumber: "#100181",
		date: "2026-08-26T11:01:00",
		client: "Daniel Alves",
		email: "daniel.alves@hotmail.com",
		document: "10000004171",
		clientPhone: "(31) 90005-891",
		clientAddress:
			"Rua Sete de Setembro, 791 - Vila Mariana, Belo Horizonte - MG, CEP 10095-503",
		clientSince: "2021-11-17",
		status: "Concluído",
		queryType: "Checkauto Standard",
		plate: "RTV1129",
		queryCode: "CS-100181",
		queryResultStatus: "success",
		value: 54.9,
		payment: "credit_card",
		queryQuantity: 1,
		card: {
			brand: "mastercard",
			holder: "Daniel Alves",
			maskedNumber: "544915******5891",
			expiration: "08/2031",
		},
	},
	{
		id: "44",
		orderNumber: "#100180",
		date: "2026-08-27T12:08:00",
		client: "Eduarda Ramos",
		email: "eduarda.ramos@gmail.com",
		document: "10000004268",
		clientPhone: "(41) 90006-028",
		clientAddress:
			"Av. Paulista, 828 - Boa Vista, Porto Alegre - RS, CEP 10097-724",
		clientSince: "2025-08-18",
		status: "Cancelado",
		queryType: "Checkauto Master",
		plate: "SUW1132",
		queryCode: "CS-100180",
		queryResultStatus: "not_performed",
		value: 59.9,
		payment: "pix",
		queryQuantity: 5,
		pixKey: "7f3c44a1-9b2e-4d5f-8a6c-0044e1b2c3d4",
	},
	{
		id: "45",
		orderNumber: "#100179",
		date: "2026-08-28T13:15:00",
		client: "Felipe Santos",
		email: "felipe.santos@hotmail.com",
		document: "10000000006165",
		clientPhone: "(51) 90006-165",
		clientAddress:
			"Rua das Flores, 865 - Petrópolis, Curitiba - PR, CEP 10099-945",
		clientSince: "2024-05-19",
		status: "Enviado",
		queryType: "Checkauto Plus",
		plate: "TVX1135",
		queryCode: "CS-100179",
		queryResultStatus: "success",
		value: 69.9,
		payment: "credit_card",
		queryQuantity: 3,
		card: {
			brand: "mastercard",
			holder: "Felipe Santos",
			maskedNumber: "544915******6165",
			expiration: "10/2028",
		},
	},
];

function buildHistory(order: BaseOrder): OrderHistoryEvent[] {
	const at = (seconds: number) =>
		dayjs(order.date).add(seconds, "second").format("YYYY-MM-DDTHH:mm:ss");
	const queries =
		order.queryQuantity === 1
			? "1 consulta"
			: `${order.queryQuantity} consultas`;

	const history: OrderHistoryEvent[] = [
		{
			status: "order_placed",
			date: at(0),
			description: `${order.queryType} · ${queries} · R$ ${priceToString(order.value)} · ${paymentLabel[order.payment]}`,
		},
		{ status: "payment_pending", date: at(8) },
	];

	if (order.status === "Cancelado") {
		return [...history, { status: "payment_canceled", date: at(300) }];
	}

	history.push({ status: "payment_paid", date: at(60) });

	if (order.queryResultStatus === "unavailable") {
		return [...history, { status: "query_unavailable", date: at(120) }];
	}

	return [
		...history,
		{ status: "query_success", date: at(120) },
		{ status: "query_emailed", date: at(130) },
	];
}

export const mockOrders: OrderRow[] = baseOrders.map((order) => ({
	...order,
	history: buildHistory(order),
}));

export function getOrderById(id: string): OrderRow | undefined {
	return mockOrders.find((order) => order.id === id);
}
